import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

// styles
import colors from '../../styles/colors'

// components
import { Empty } from '../reviewList/components'
import Loading from '../../components/atom/loading/Loading'

// images
import QImg from '../../assets/image/Q.svg'
import DownImg from '../../assets/image/arrow/ic-down.svg'

const PosInfo = ({ allItems }) => {
  const [items, setItems] = useState([])

  // POS 주문접수
  const [selectedIdx, setSelectedIdx] = useState(0)
  const [selectedFAQItem, setSelectedFAQItem] = useState([])
  const [categoryItems, setCategoryItems] = useState([])

  useEffect(() => {
    const categories = [...new Set(allItems?.map((item) => item.category))]
    setCategoryItems(categories)
  }, [allItems])

  useEffect(() => {
    if (categoryItems) {
      handleFAQTab(selectedIdx, categoryItems[selectedIdx])
      //초기 pos주문프로그램 활성화 상태
      handleFAQAccordion(0)
    }
  }, [categoryItems])

  const filterItems = (category) => {
    let filteredItems = []
    allItems?.filter((item) => {
      if (item.category === category) {
        filteredItems.push(item)
      }
    })
    setItems(filteredItems)
  }

  const handleFAQTab = (idx, category) => {
    filterItems(category)
    setSelectedFAQItem([])
    setSelectedIdx(idx)
  }

  const handleFAQAccordion = (idx) => {
    setSelectedFAQItem((prev) => {
      if (prev.includes(idx)) {
        return prev.filter((id) => id !== idx)
      } else {
        return [...prev, idx]
      }
    })
  }

  return (
    <>
      {!allItems ? (
        <Loading />
      ) : (
        <>
          <FAQTabs>
            {categoryItems?.map((item, idx) => (
              <FAQTabBtn
                isSelected={selectedIdx === idx}
                onClick={() => handleFAQTab(idx, item)}
                key={idx}
              >
                {item}
              </FAQTabBtn>
            ))}
          </FAQTabs>
          {items.length > 0 ? (
            <FAQBox>
              {items.map((item, idx) => (
                <ItemWrapper key={idx}>
                  <HeaderItem>
                    <img src={QImg} />
                    <div onClick={() => handleFAQAccordion(idx)}>
                      {item.title}
                    </div>
                    <img
                      src={DownImg}
                      onClick={() => handleFAQAccordion(idx)}
                    />
                  </HeaderItem>
                  {selectedFAQItem.includes(idx) && (
                    <BodyItem>{item.description}</BodyItem>
                  )}
                </ItemWrapper>
              ))}
            </FAQBox>
          ) : (
            <Wrapper>
              <Empty pointTxt={'등록된 리뷰'} txt={'가 없습니다.'} />
            </Wrapper>
          )}
        </>
      )}
    </>
  )
}

export default PosInfo

const FaqWrap = styled.div`
  width: 100%;
  max-width: 768px;
  margin: 0 auto;
`

const FAQTabs = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 10px;

  margin-bottom: 30px;
  @media ${(props) => props.theme.mobile} {
    padding: 20px 20px 0;
  }
`

const FAQTabBtn = styled.button`
  padding: 8px 15px;
  border-radius: 17px;
  background-color: ${(props) =>
    props.isSelected ? `${colors.mainG}` : `${colors.G3}`};
  text-align: center;
  font-size: 16px;
  color: ${(props) => (props.isSelected ? `${colors.W1}` : `${colors.BK}`)};
`

const ItemWrapper = styled.div`
  padding-top: 20px;
  display: flex;
  flex-direction: column;

  @media ${(props) => props.theme.mobile} {
    padding: 20px 20px 0 20px;
  }
`

const HeaderItem = styled.div`
  display: flex;
  align-items: center;
  padding: 0 20px;

  @media ${(props) => props.theme.mobile} {
    padding: 0;
  }

  img:nth-child(1) {
    width: 16px;
    height: 29px;
    margin-right: 46px;

    @media ${(props) => props.theme.mobile} {
      margin-right: 20px;
    }
  }

  img:nth-child(3) {
    width: 12px;
    height: 12px;
    cursor: pointer;
    transition: transform 0.5s ease;
    transform: ${(props) =>
      props.isActive ? `rotate(180deg)` : `rotate(0deg)`};
  }

  div {
    flex: 1;
    font-size: 16px;
    color: ${colors.BK};
    cursor: pointer;
  }
`

const BodyItem = styled.div`
  margin-top: 20px;
  padding: 20px;
  border-radius: 8px;
  background-color: ${colors.W4};
  font-size: 16px;
  line-height: 1.56;
  word-break: break-all;
  white-space: pre-wrap;
  color: ${colors.BK};
`

const FAQBox = styled.div`
  border-top: 1px solid #e5e5e5;
`

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media ${(props) => props.theme.mobile} {
    padding: 0 20px;
  }
`
